import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ENVIRONMENT_WEBSITE_TOKEN } from '@campus/environment';
import { ClassGroupInterface, ContactFormEntryInterface } from '@campus/public-portal';
import { DcrAnimatedKai } from '@diekeure/dcr-components';
import { Observable, Subscription } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { PersonWithToken } from '../../kabas.interfaces';
import { HomePageViewModel } from './home-page.viewmodel';

@Component({
  standalone: false,
  selector: 'kabas-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent implements OnInit, OnDestroy {
  @ViewChild('kai') kai: ElementRef<DcrAnimatedKai>;
  @ViewChild('cta') cta: ElementRef<HTMLDivElement>;

  @HostBinding('class.kabas-homepage')
  hasKabasHomepageClass = true;

  public showModal = false;

  public user$: Observable<PersonWithToken>;
  public isMaintenanceMode$: Observable<boolean>;
  public statusPageUrl: string;

  // used to tunnel back contact response from API to the contact form
  public contactSuccess$: Observable<boolean>;
  public classGroups$: Observable<ClassGroupInterface[]>;
  public qrScanner = false;

  private subscriptions: Subscription = new Subscription();

  public subjects = [
    'Ik wil een gratis opleiding over Kabas',
    'Ik wil een demo over Kabas',
    'Ik wil meer info over Kabas',
    'Ik heb een vraag over mijn bestelling',
    'Ik heb een technische vraag of probleem',
    'Ik wil een fout melden',
    'Ik heb een andere vraag',
  ];

  private vm = inject(HomePageViewModel);
  private environmentWebsite = inject(ENVIRONMENT_WEBSITE_TOKEN);
  private title = inject(Title);

  public route = inject(ActivatedRoute);

  ngOnInit() {
    this.title.setTitle('Kabas');
    this.contactSuccess$ = this.vm.contactSuccess$;
    this.user$ = this.vm.user$.pipe(shareReplay(1));

    this.isMaintenanceMode$ = this.vm.isMaintenanceMode$;
    this.statusPageUrl = this.environmentWebsite.statusPageUrl;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.cta?.nativeElement?.removeEventListener('mouseenter', this._wave.bind(this));
    this.cta?.nativeElement?.removeEventListener('mouseleave', this._idle.bind(this));
  }

  loadedKai(event: Event) {
    const el = this.cta?.nativeElement;
    if (el) {
      el.addEventListener('mouseenter', this._wave.bind(this));
      el.addEventListener('mouseleave', this._idle.bind(this));
    }
  }

  private _wave() {
    this.kai?.nativeElement?.setState('WAVING');
  }
  private _idle() {
    this.kai?.nativeElement?.setState('IDLE');
  }

  goToPlatform() {
    // redirect user to portal based on the role
    this.vm.redirectToPlatform();
  }

  public contactFormSubmitted(formValues: ContactFormEntryInterface) {
    this.vm.sendContactForm(formValues);
  }
}
